"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default = function _default(_ref) {
  var typeId = _ref.typeId;
  return "\n".concat(typeId ? "\n    <span class=\"title-format-badge contrast u-allCaps\"><i class=\"icon-".concat(typeId, "\"></i>").concat(window.html(typeId), "</span>\n") : '', "\n");
};

exports["default"] = _default;